import type { PermissionRoles } from '../../../../auth/common/interfaces/permission-roles';

export enum ManagementPanelPermission {
  // Employees
  EMPLOYEES_GET = 'employees.get',
  EMPLOYEES_ADD = 'employees.add',
  EMPLOYEES_EDIT = 'employees.edit',
  EMPLOYEES_DELETE = 'employees.delete',
  EMPLOYEES_COPY_INVITE_LINK = 'employees.copyInviteLink',

  // Contractors
  CONTRACTORS_GET = 'contractors.get',
  CONTRACTORS_ADD = 'contractors.add',
  CONTRACTORS_EDIT = 'contractors.edit',

  // Points of interest
  POINTS_OF_INTEREST_GET = 'pointsOfInterest.get',
  POINTS_OF_INTEREST_ADD = 'pointsOfInterest.add',
  POINTS_OF_INTEREST_EDIT = 'pointsOfInterest.edit',
  POINTS_OF_INTEREST_DELETE = 'pointsOfInterest.delete',

  // Bases
  BASES_GET = 'bases.get',
  BASES_ADD = 'bases.add',
  BASES_EDIT = 'bases.edit',
  BASES_DELETE = 'bases.delete',

  // Engine config
  ENGINE_CONFIG_GET = 'engineConfig.get',
  ENGINE_CONFIG_EDIT = 'engineConfig.edit',

  // Business
  BUSINESS_GET = 'business.get',
  BUSINESS_EDIT = 'business.edit',

  // Dictionaries
  DICTIONARIES_GET = 'dictionaries.get',
  DICTIONARIES_ADD = 'dictionaries.add',
  DICTIONARIES_EDIT = 'dictionaries.edit',
  DICTIONARIES_DELETE = 'dictionaries.delete',

  // Documents
  DOCUMENTS_GET = 'documents.get',
  DOCUMENTS_EDIT = 'documents.edit',

  // Integrations
  INTEGRATIONS_GET = 'integrations.get',
  INTEGRATIONS_EDIT = 'integrations.edit',
}

export const getManagementPanelPermissions = (
  roles: PermissionRoles,
): Record<ManagementPanelPermission, boolean> => {
  const { isAdmin, isManager } = roles;
  return {
    [ManagementPanelPermission.EMPLOYEES_GET]: true,
    [ManagementPanelPermission.EMPLOYEES_ADD]: isManager,
    [ManagementPanelPermission.EMPLOYEES_EDIT]: isManager,
    [ManagementPanelPermission.EMPLOYEES_DELETE]: isManager,
    [ManagementPanelPermission.EMPLOYEES_COPY_INVITE_LINK]: isAdmin,

    [ManagementPanelPermission.CONTRACTORS_GET]: true,
    [ManagementPanelPermission.CONTRACTORS_ADD]: true,
    [ManagementPanelPermission.CONTRACTORS_EDIT]: true,

    [ManagementPanelPermission.POINTS_OF_INTEREST_GET]: true,
    [ManagementPanelPermission.POINTS_OF_INTEREST_ADD]: true,
    [ManagementPanelPermission.POINTS_OF_INTEREST_EDIT]: true,
    [ManagementPanelPermission.POINTS_OF_INTEREST_DELETE]: true,

    [ManagementPanelPermission.BASES_GET]: true,
    [ManagementPanelPermission.BASES_ADD]: isManager,
    [ManagementPanelPermission.BASES_EDIT]: isManager,
    [ManagementPanelPermission.BASES_DELETE]: isManager,

    [ManagementPanelPermission.ENGINE_CONFIG_GET]: true,
    [ManagementPanelPermission.ENGINE_CONFIG_EDIT]: isManager,

    [ManagementPanelPermission.BUSINESS_GET]: true,
    [ManagementPanelPermission.BUSINESS_EDIT]: isAdmin,

    [ManagementPanelPermission.DICTIONARIES_GET]: true,
    [ManagementPanelPermission.DICTIONARIES_ADD]: true,
    [ManagementPanelPermission.DICTIONARIES_EDIT]: true,
    [ManagementPanelPermission.DICTIONARIES_DELETE]: true,

    [ManagementPanelPermission.DOCUMENTS_GET]: isAdmin,
    [ManagementPanelPermission.DOCUMENTS_EDIT]: isAdmin,

    [ManagementPanelPermission.INTEGRATIONS_GET]: isManager,
    [ManagementPanelPermission.INTEGRATIONS_EDIT]: isManager,
  };
};
